import { compact, isEmpty } from "lodash/fp";

import {
  GPT_ENTITY_KEYS,
  SCORE_METRICS,
} from "@app/analytics/Home/components/constants";
import type { MeetingReportFeedItem } from "@app/analytics/Home/types";

export const itemHasGptEntities = (item: MeetingReportFeedItem) => {
  return !isEmpty(
    compact(GPT_ENTITY_KEYS.map((key) => item.data.metrics[key]))
  );
};

export const itemHasAffectiveMetrics = (item: MeetingReportFeedItem) => {
  return !isEmpty(
    compact(SCORE_METRICS.map((metric) => item.data.metrics[metric]))
  );
};
